import axios from "axios";
import { get } from "lodash";
import { FULFILLED, PENDING, REJECTED } from "./action-type.util";

const ACTION_TYPES = {
  FETCH_PREMIUM_DETAILS: "applications/FETCH_PREMIUM_DETAILS",
  SAVE_PREMIUM_DETAILS: "applications/SAVE_PREMIUM_DETAILS",
};

const initialState = {
  loading: false,
  premiumDetails: null,
};

export type ApplicationPremiumDetailsState = Readonly<typeof initialState>;

const parsePremiumDetails = premiumDetails => {
  return {
    ...premiumDetails,
    modalPremium: get(premiumDetails, "modalPremium") || 0,
    annualPremium: get(premiumDetails, "annualPremium") || 0,
    cashWithAppAmount: get(premiumDetails, "cashWithAppAmount") || 0,
    annualizedPremium: get(premiumDetails, "annualizedPremium") || 0,
  };
};

/**
 * Application Premium Details Reducer
 */
export default (state: ApplicationPremiumDetailsState = initialState, action): ApplicationPremiumDetailsState => {
  switch (action.type) {
    case PENDING(ACTION_TYPES.FETCH_PREMIUM_DETAILS):
    case PENDING(ACTION_TYPES.SAVE_PREMIUM_DETAILS):
      return { ...state, loading: true };

    case FULFILLED(ACTION_TYPES.FETCH_PREMIUM_DETAILS):
      return { ...state, loading: false, premiumDetails: parsePremiumDetails(action.payload.data) };

    case FULFILLED(ACTION_TYPES.SAVE_PREMIUM_DETAILS):
      return { ...state, loading: false };

    case REJECTED(ACTION_TYPES.FETCH_PREMIUM_DETAILS):
    case REJECTED(ACTION_TYPES.SAVE_PREMIUM_DETAILS):
      return { ...state, loading: false };

    default:
      return state;
  }
};

/**
 * Actions for fetching Premium details data
 */

export const fetchPremiumDetails = (applicationId: string) => ({
  type: ACTION_TYPES.FETCH_PREMIUM_DETAILS,
  meta: { applicationId },
  payload: axios.get(`/applications/${applicationId}/premiumDetails`),
});

/**
 * Action to save or update Premium details
 */
export const savePremiumDetails = (applicationId, premiumData) => ({
  type: ACTION_TYPES.SAVE_PREMIUM_DETAILS,
  payload: axios.post(`/applications/${applicationId}/premiumDetails`, premiumData, {
    headers: { "Content-Type": "application/json" },
  }),
});
